import { render } from "./Treasury.vue?vue&type=template&id=0255c6d0&scoped=true"
import script from "./Treasury.vue?vue&type=script&lang=js"
export * from "./Treasury.vue?vue&type=script&lang=js"

import "./Treasury.vue?vue&type=style&index=0&id=0255c6d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0255c6d0"]])

export default __exports__